"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCEL_ENCOUNTER_RESPONSE_EXAMPLE = exports.ENCOUNTER_WORKFLOW_RESPONSE_EXAMPLE = void 0;
const clinical_common_response_1 = require("./clinical-common.response");
exports.ENCOUNTER_WORKFLOW_RESPONSE_EXAMPLE = {
    encounter: clinical_common_response_1.ENCOUNTER_RESPONSE_EXAMPLE,
    timeline: [clinical_common_response_1.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE],
    notificationSent: false,
};
exports.CANCEL_ENCOUNTER_RESPONSE_EXAMPLE = {
    encounterId: clinical_common_response_1.ENCOUNTER_RESPONSE_EXAMPLE.id,
    timeline: [clinical_common_response_1.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE],
    notificationSent: false,
};
//# sourceMappingURL=clinical-encounter.response.js.map